import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHelperService } from '../../utilities/http-helper/http-helper.service';
import { Customer } from '../../models/customer/customer.model';
import { Appointment } from '../../models/customer/appointment.model';
import { CustomerInput } from '../../models/customer/customer-input';
import { CustomerDetails } from '../../models/customer/customer-details';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient, private httpHelper: HttpHelperService) { }

  getCustomerListPagination(paramsReq: any): Observable<Customer> {
    let params = new HttpParams()
      .set("PageNumber", paramsReq.PageNumber)
      .set("PageSize", paramsReq.PageSize)
      .set('FilterId', paramsReq.FilterId)
      .set('SearchTerm',paramsReq.SearchTerm)
    const apiUrl = this.httpHelper.getApiUrl('api/Appointments/GetCustomersByStylistIdWithPagination')
    return this.http.get<Customer>(apiUrl, { params: params });
  }

  getAppointmentListWithPagination(paramsReq: any): Observable<Appointment> {
    let params = new HttpParams()
      .set("PageNumber", paramsReq.PageNumber)
      .set("PageSize", paramsReq.PageSize)
      .set('FilterId', paramsReq.FilterId)
      .set('StylistId', paramsReq.StylistId)
    const apiUrl = this.httpHelper.getApiUrl('api/Appointments/GetAllAppointmentsByCustomerId')
    return this.http.get<Appointment>(apiUrl, { params: params });
  }

  addCustomer(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Customers/CreateCustomer`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post<CustomerInput>(apiUrl, data, requestOptions);
  }

  UpdateCustomer(data:any):Observable<any>{
    const apiUrl = this.httpHelper.getApiUrl('/api/Customers/UpdateCustomer');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<CustomerInput>(apiUrl,data, requestOptions);
  }

  getCustomerbyId(paramsReq:any): Observable<CustomerDetails>{
    let param = new HttpParams()
        .set('userId',paramsReq.userId)
        .set('stylistId',paramsReq.stylistId)
    const apiUrl = this.httpHelper.getApiUrl('api/Customers/GetCustomerByIdAndStylistId');
    return this.http.get<any>(apiUrl,{params: param})
  }

  sendPosterToCus(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl('/api/Stylists/SendMailWithQR');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }
  
}
